import React, { Component } from "react";
import { connect } from "react-redux";
import Form from "react-validation/build/form";
//import Button from "react-validation/build/button";
import {
  getUserDetailsByUserId,
  getAchievementsByStudentId,
  getLanguageknownsByStudentId,
  clearUpdate,
  getFormVerifyDetailsByStudentId,
  admissionInsertVerifyDetails,
  getAllAdmissionFormConfigurationByFormId,
  getAdmissionTotalFormFeesByStudentId,
  payOnlinePayment,
  getStudentStatusDetailsByUserId,
  WithoutAdmissionFormFeesDetails,
} from "../../actions";
import moment from "moment";
import AcademicInfoPrint from "./AcademicInfoPrint";
import Modal from "react-responsive-modal";
import notification from "../../utils/notification";
const keys = require("../../config/keys");

class AdmissionVerifyPrint extends Component {
  constructor(props) {
    super(props);
    this.state = {
      allLanguagesData: [],
      allAchievementsData: [],
      modelOpen: false,
      btnDisabled: true,
      admStatusDetails: [],
    };
  }

  async componentWillMount() {
    this.props.getUserDetailsByUserId(this.props.auth.userId);
    this.props.getAllAdmissionFormConfigurationByFormId(this.props.FormId);
    const PromiseArry = [
      this.props.getAchievementsByStudentId(this.props.auth.userId),
      this.props.getLanguageknownsByStudentId(this.props.auth.userId),
      this.props.getFormVerifyDetailsByStudentId(
        this.props.FormId,
        this.props.auth.userId
      ),
      this.props.getAdmissionTotalFormFeesByStudentId(
        this.props.FormId,
        this.props.auth.userId
      ),

      // this.props.getStudentStatusDetailsByUserId(this.props.auth.userId)
      this.props.getStudentStatusDetailsByUserId(
        this.props.auth.userId,
        this.props.auth.admissionConfig.AyId
      ),
    ];
    await Promise.all(PromiseArry);

    if (this.props.admissionTotalFormFees.length > 0) {
      await this.setState({
        FormFees: this.props.admissionTotalFormFees[0].FormFees,
      });
    }
    if (this.props.admissionVerifyDetails.length > 0) {
      await this.setState({
        IsVerifyId: this.props.admissionVerifyDetails[0].Id,
        IsFormFeesPaid: this.props.admissionVerifyDetails[0].IsFormFeesPaid,
        IsVerifyUser: this.props.admissionVerifyDetails[0].IsVerify,
        AdmissionNo: this.props.admissionVerifyDetails[0].AdmissionNo,
        AdmissionDate:
          this.props.admissionVerifyDetails[0].AdmissionDate !== "" &&
          moment(this.props.admissionVerifyDetails[0].AdmissionDate).format(
            "DD-MM-YYYY"
          ),
      });
    }
    if (this.props.admissionStudentStatusDetails.length > 0) {
      var admStatusDetails = this.props.admissionStudentStatusDetails.filter(
        (i) => {
          return i.AdmFormGroupId === parseInt(this.props.FormId, 10);
        }
      );
      await this.setState({
        admStatusDetails,
        PendingAmount: admStatusDetails[0].PendingAmount,
        IsVerifiedByUser: admStatusDetails[0].IsVerify,
        AfdId: admStatusDetails[0].afdId,
      });
    }
    await this.setState({
      allAchievementsData: this.props.achievementByStudent,
      allLanguagesData: this.props.languageKnownByStudent,
    });
  }
  onOpenModal = () => {
    this.setState({ modelOpen: true });
  };
  onCloseModal = () => {
    this.setState({ modelOpen: false });
  };
  handleCheckVerify = (e) => {
    this.setState({
      IsVerify: e.target.checked !== true ? 0 : 1,
      btnDisabled: false,
    });
    if (!e.target.checked) {
      this.setState({ btnDisabled: true });
    }
  };

  makeOnlinePayment = (item) => {
    var feesAmount = 0;
    var CourseIDS = "";
    // if (item.CoursewiseFees === 1) {
    //   feesAmount = item.CourseList.reduce((sum, item) => {
    //     return (sum = sum + item.CourseFees);
    //   }, 0);
    // } else {
    //   feesAmount = item.FormFees;
    // }
    item.CourseList.filter((i) => {
      return i.CoursewiseFormFeesPaidSts === 0;
    }).map((item) => {
      CourseIDS = CourseIDS + item.CourseID + "|";
    });
    if (CourseIDS.length > 0) {
      CourseIDS = CourseIDS.toString().substring(0, CourseIDS.length - 1);
    }
    feesAmount = item.PendingAmount;

    // console.log("CourseIDS", CourseIDS);
    var orderInfo = {
      admissionNo: this.state.AdmissionNo,
      name: this.props.userDetails.FullUserName,
      mobileNo: this.props.userDetails.StudMobNo,
      email: this.props.userDetails.Email,
      programApplied: item.CourseList.map((data) =>
        data.SyllabusName.trim()
      ).join(","),
    };
    var payRequest = {
      id: this.props.auth.paymentvendor[0].id,
      vpc_Amount: feesAmount,
      vpc_MerchTxnRef:
        this.props.auth.userId +
        "|" +
        item.AdmFormGroupId +
        "|" +
        item.afdId +
        "|" +
        this.state.AdmissionNo +
        "|1",
      vpc_OrderInfo:
        this.props.userDetails.FirstName +
        "_" +
        this.props.userDetails.StudMobNo, //JSON.stringify(orderInfo),
      // vpc_ReturnURL: "http://localhost:5000/payment", //"http://localhost:3001",//
      vpc_Version: 1,
      vpc_OrderInfo1: JSON.stringify(orderInfo),
      vpc_firstname: this.props.userDetails.FullUserName,
      vpc_email: this.props.userDetails.Email,
      vpc_udf1: this.props.userDetails.StudMobNo,

      // Commented & Added By Pinal Patel 06-May-2020
      // vpc_udf2: this.props.auth.userId,
      vpc_udf2: this.props.auth.userId + "|Admission Form Fees",

      vpc_udf3: item.AdmFormGroupId,
      vpc_udf4: CourseIDS,
      vpc_udf5: this.state.AdmissionNo,
      vpc_udf6: "1|" + CourseIDS,
      vpc_lastName: this.props.auth.clientCode,
    };
    //console.log("payRequest", payRequest);
    if (this.props.auth.paymentvendor.length === 1) {
      this.props.payOnlinePayment(payRequest);
    }
  };

  handleSubmit = async (event) => {
    event.preventDefault();
    var verifyData = {
      Id: this.state.IsVerifyId,
      IsVerify: this.state.IsVerify,
      IsVerifyBy: this.props.auth.userId,
      AdmissionNo: this.state.AdmissionNo,
      FormId: this.props.FormId,
      StudentId: this.props.auth.userId,
      AfdId: this.state.AfdId,
    };
    if (this.state.PendingAmount > 0) {
      this.props.WithoutAdmissionFormFeesDetails(verifyData);
    }
    let verified = await this.props.admissionInsertVerifyDetails(verifyData);
    if (verified) {
      this.onCloseModal();
      this.setState({
        IsVerifyUser: this.state.IsVerify,
      });
      notification("success", "Success", "Verify Successfully");
    }
  };
  render() {
    return (
      <div
        className={this.state.IsVerifyUser ? "main-bg" : "main-bg  doNotPrint"}
      >
        <Modal
          open={this.state.modelOpen}
          onClose={this.onCloseModal}
          closeOnOverlayClick={false}
          closeOnEsc={false}
          classNames={{
            modal: "modelOf90Percentage",
          }}
        >
          <Form onSubmit={this.handleSubmit.bind(this)}>
            {this.props.admissionFormList.length > 0 && (
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Verify</h5>
                </div>
                <div className="modal-text">
                  <h5 className="inner-title mb-3">
                    Declaration by the Applicant
                  </h5>
                  {this.props.admissionFormList
                    .filter((data) => {
                      return data.ID === parseInt(this.props.FormId, 10);
                    })
                    .map((item, index) => {
                      return (
                        <div
                          dangerouslySetInnerHTML={{ __html: item.Declaration }}
                          key={index}
                        />
                      );
                    })}
                  <div className="form-group mb-0 mt-3">
                    <input
                      type="checkbox"
                      id="IsVerify"
                      name="IsVerify"
                      checked={this.state.IsVerify ? true : false}
                      onChange={this.handleCheckVerify}
                    />
                    <label className="checkbox-inline" htmlFor="IsVerify">
                      Yes I Agree
                    </label>
                  </div>
                </div>
                <div className="modal-footer">
                  <button
                    type="submit"
                    className="btn btn-success btn-lg theme-btn"
                    onClick={this.onCloseModal}
                    disabled={this.state.btnDisabled}
                  >
                    <i className="fa fa-check-circle" aria-hidden="true" />
                    Yes I Agree
                  </button>
                </div>
              </div>
            )}
          </Form>
        </Modal>

        <h2 className="page-title sub-title">Verify and Print Form</h2>

        <div className="pageBreakheader">
          <header className="print-header">
            <div className="printAdmissionLogo">
              <img src={keys.websiteSetting.PrintLogo} alt="Logo" />
            </div>
            {this.props.admissionFormList.length > 0 && (
              <div>
                {this.props.admissionFormList
                  .filter((data) => {
                    return data.ID === parseInt(this.props.FormId, 10);
                  })
                  .map((item, index) => {
                    return (
                      <div className="documentData" key={index}>
                        <h2 className="text-center"> {item.FormGroupName}</h2>
                        <ul className="documentDataList">
                          <li>
                            <strong>Application No</strong> :{" "}
                            {this.state.AdmissionNo || ""}
                          </li>
                          <li className="text-capitalize">
                            <strong>Applicant Name</strong> :{" "}
                            {this.props.userDetails.FullUserName || ""}
                          </li>
                        </ul>
                        <p className="formDate">
                          <strong>Application Date</strong> :{" "}
                          {this.state.AdmissionDate}
                          <br />
                          <strong>Form Fees</strong> :{" "}
                          {this.state.FormFees ? `₹${this.state.FormFees}` : ""}
                        </p>
                      </div>
                    );
                  })}
              </div>
            )}
          </header>
          <div className="mb-3 print-table">
            {this.props.admissionFormConfiguration.filter(
              (i) => i.DisplayStatus === 1 && i.AdmFormGroupSectionId === 7
            ).length > 0 && (
              <table className="table table-bordered dashboard-table mb-1">
                <thead>
                  <tr className="table-light">
                    <th colSpan="4">Personal Detail</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td width="33%">
                      <span>First Name</span> :&nbsp;
                      {this.props.userDetails.FirstName}
                    </td>
                    <td width="30%">
                      <span>Middle Name</span> :&nbsp;
                      {this.props.userDetails.MiddleName}
                    </td>
                    <td width="24%">
                      <span>Last Name</span> :&nbsp;
                      {this.props.userDetails.LastName}
                    </td>
                    <td
                      rowSpan="4"
                      className="align-top dashuser_photo userPick"
                      width="150px"
                    >
                      {this.props.userDetails.ProPic !== null &&
                      this.props.userDetails.ProPic !== undefined ? (
                        <img
                          src={
                            keys.ServicePath + this.props.userDetails.ProPic ||
                            ""
                          }
                          className="mx-auto d-block img-thumbnail"
                          alt="profile"
                        />
                      ) : (
                        ""
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <span>Gender</span> :&nbsp;
                      {this.props.userDetails.Gender}
                    </td>
                    <td>
                      <span>DOB</span> :&nbsp;
                      {moment(this.props.userDetails.DOB).isValid()
                        ? moment(this.props.userDetails.DOB).format(
                            "DD-MM-YYYY"
                          )
                        : ""}
                    </td>
                    <td>
                      <span>Blood Group</span> :&nbsp;
                      {this.props.userDetails.BloodGroup}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <span>Marital Status</span> :&nbsp;
                      {this.props.userDetails.MaritalStatus}
                    </td>
                    <td>
                      <span>Nationality</span> :&nbsp;
                      {this.props.userDetails.Nationality}
                    </td>
                    <td>
                      <span>Religion</span> :&nbsp;
                      {this.props.userDetails.ReligionName}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <span>Caste Category</span> :&nbsp;
                      {this.props.userDetails.CasteCategory}
                    </td>
                    <td>
                      <span>Caste</span> :&nbsp;
                      {this.props.userDetails.Caste}
                    </td>
                    <td>
                      <span>Sub-Caste</span> :&nbsp;
                      {this.props.userDetails.SubCaste}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <span>Email</span> :&nbsp;
                      {this.props.userDetails.Email}
                    </td>
                    <td>
                      <span>Mobile</span> :&nbsp;
                      {this.props.userDetails.StudMobNo}
                    </td>
                    <td colSpan="2">
                      <span>Emergency Mobile No.</span> :&nbsp;
                      {this.props.userDetails.EmergencyMobNo}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <span>Aadhar No</span> :&nbsp;
                      {this.props.userDetails.AadharCard}
                    </td>
                    <td>
                      <span>Physically Challenged</span> :&nbsp;
                      {this.props.userDetails.PhysicallyChallenge === 1
                        ? "Yes"
                        : "No"}
                    </td>
                    {this.props.userDetails.PhysicallyChallenge === 1 && (
                      <td>
                        <span>Physically Challenged Info</span> :&nbsp;
                        {this.props.userDetails.PhysicallyChallengeInfo}
                      </td>
                    )}
                    <td>
                      <span>Occupation</span> :&nbsp;
                      {this.props.userDetails.Occupation}
                    </td>
                    {this.props.userDetails.PhysicallyChallenge !== 1 && <td />}
                  </tr>
                  <tr>
                    <td>
                      <span>MotherTongue</span> :&nbsp;
                      {this.props.userDetails.MotherTounge}
                    </td>
                    <td>
                      <span>Minority</span> :&nbsp;
                      {this.props.userDetails.Occupation === 1 ? "Yes" : "No"}
                    </td>
                    <td colSpan="2" />
                  </tr>
                </tbody>
              </table>
            )}
            {this.props.admissionFormConfiguration.filter(
              (i) => i.DisplayStatus === 1 && i.AdmFormGroupSectionId === 8
            ).length > 0 && (
              <table className="table table-bordered dashboard-table mb-1 ">
                <thead>
                  <tr>
                    <th colSpan="4" className="table-light">
                      Permanent Address
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td width="33%">
                      <span>Permanent Address</span> :&nbsp;
                      {this.props.userDetails.Address}
                    </td>
                    <td width="28%">
                      <span>Area</span> :&nbsp;
                      {this.props.userDetails.Area}
                    </td>
                    <td width="20%">
                      <span>Country</span> :&nbsp;
                      {this.props.userDetails.CountryName}
                    </td>
                    <td>
                      <span>State</span> :&nbsp;
                      {this.props.userDetails.StateName}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <span>City</span> :&nbsp;
                      {this.props.userDetails.CityName}
                    </td>
                    <td>
                      <span>Pin Code</span> :&nbsp;
                      {this.props.userDetails.PinCode}
                    </td>
                    <td colSpan="2">
                      <span>Phone</span> :&nbsp;
                      {this.props.userDetails.Phone}
                    </td>
                  </tr>
                </tbody>
              </table>
            )}

            {this.props.admissionFormConfiguration.filter(
              (i) => i.DisplayStatus === 1 && i.AdmFormGroupSectionId === 9
            ).length > 0 && (
              <table className="table table-bordered dashboard-table mb-1 ">
                <thead>
                  <tr>
                    <th colSpan="4" className="table-light">
                      Correspondence Address
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td width="33%">
                      <span>Correspondence Address</span> :&nbsp;
                      {this.props.userDetails.CorrespondenceAddress}
                    </td>
                    <td width="28%">
                      <span>Area</span> :&nbsp;
                      {this.props.userDetails.CorrespondenceArea}
                    </td>
                    <td width="20%">
                      <span>Country</span> :&nbsp;
                      {this.props.userDetails.CorrespondCountryName}
                    </td>
                    <td>
                      <span>State</span> :&nbsp;
                      {this.props.userDetails.CorrespondStateName}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <span>City</span> :&nbsp;
                      {this.props.userDetails.CorrespondCityName}
                    </td>
                    <td>
                      <span>Pin Code</span> :&nbsp;
                      {this.props.userDetails.CorrespondencePinCode}
                    </td>
                    <td colSpan="2">
                      <span>Phone</span> :&nbsp;
                      {this.props.userDetails.CorrespondencePhone}
                    </td>
                  </tr>
                </tbody>
              </table>
            )}

            {this.props.admissionFormConfiguration.filter(
              (i) => i.DisplayStatus === 1 && i.AdmFormGroupSectionId === 10
            ).length > 0 && (
              <table className="table table-bordered dashboard-table mb-1 ">
                <thead>
                  <tr>
                    <th colSpan="4" className="table-light">
                      Family Details
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {(this.props.userDetails.FatherName !== "" ||
                    this.props.userDetails.FatherMobNo !== "" ||
                    this.props.userDetails.FatherEmail !== "" ||
                    this.props.userDetails.FatherOccupation !== "") && (
                    <tr>
                      <td width="33%">
                        <span>Father Name</span> :&nbsp;
                        {this.props.userDetails.FatherName}
                      </td>
                      <td width="28%">
                        <span>Father Mobile</span> :&nbsp;
                        {this.props.userDetails.FatherMobNo}
                      </td>
                      <td width="20%">
                        <span>Father Email</span> :&nbsp;
                        {this.props.userDetails.FatherEmail}
                      </td>
                      <td>
                        <span>Father Occupation</span> :&nbsp;
                        {this.props.userDetails.FatherOccupation}
                      </td>
                    </tr>
                  )}

                  {(this.props.userDetails.MotherName !== "" ||
                    this.props.userDetails.MotherMobNo !== "" ||
                    this.props.userDetails.MotherEmail !== "" ||
                    this.props.userDetails.MotherOccupation !== "") && (
                    <tr>
                      <td>
                        <span>Mother Name</span> :&nbsp;
                        {this.props.userDetails.MotherName}
                      </td>
                      <td>
                        <span>Mother Mobile</span> :&nbsp;
                        {this.props.userDetails.MotherMobNo}
                      </td>
                      <td>
                        <span>Mother Email</span> :&nbsp;
                        {this.props.userDetails.MotherEmail}
                      </td>
                      <td>
                        <span>Mother Occupation</span> :&nbsp;
                        {this.props.userDetails.MotherOccupation}
                      </td>
                    </tr>
                  )}

                  {(this.props.userDetails.GuardianName !== "" ||
                    this.props.userDetails.GuardianMobNo !== "" ||
                    this.props.userDetails.GuardianEmail !== "" ||
                    this.props.userDetails.GuardianOccupation !== "" ||
                    this.props.userDetails.GuardianRelation !== "") && (
                    <tr>
                      <td>
                        <span>Guardian Name</span> :&nbsp;
                        {this.props.userDetails.GuardianName}
                      </td>
                      <td>
                        <span>Guardian Mobile</span> :&nbsp;
                        {this.props.userDetails.GuardianMobNo}
                      </td>
                      <td>
                        <span>Guardian Email</span> :&nbsp;
                        {this.props.userDetails.GuardianEmail}
                      </td>
                      <td>
                        <span>Guardian Occupation</span> :&nbsp;
                        {this.props.userDetails.GuardianOccupation}
                      </td>
                    </tr>
                  )}
                  {(this.props.userDetails.GuardianName !== "" ||
                    this.props.userDetails.GuardianMobNo !== "" ||
                    this.props.userDetails.GuardianEmail !== "" ||
                    this.props.userDetails.GuardianOccupation !== "" ||
                    this.props.userDetails.GuardianRelation !== "") && (
                    <tr>
                      <td colSpan="4">
                        <span>Guardian Relation</span> :&nbsp;
                        {this.props.userDetails.GuardianRelation}
                      </td>
                    </tr>
                  )}

                  {(this.props.userDetails.SpouseName !== "" ||
                    this.props.userDetails.SpouseMobNo !== "" ||
                    this.props.userDetails.SpouseEmail !== "" ||
                    this.props.userDetails.SpouseOccupation !== "" ||
                    this.props.userDetails.SpouseRelation !== "") && (
                    <tr>
                      <td>
                        <span>Spouse Name</span> :&nbsp;
                        {this.props.userDetails.SpouseName}
                      </td>
                      <td>
                        <span>Spouse Mobile</span> :&nbsp;
                        {this.props.userDetails.SpouseMobNo}
                      </td>
                      <td>
                        <span>Spouse Email</span> :&nbsp;
                        {this.props.userDetails.SpouseEmail}
                      </td>
                      <td>
                        <span>Spouse Occupation</span> :&nbsp;
                        {this.props.userDetails.SpouseOccupation}
                      </td>
                    </tr>
                  )}

                  {(this.props.userDetails.SpouseName !== "" ||
                    this.props.userDetails.SpouseMobNo !== "" ||
                    this.props.userDetails.SpouseEmail !== "" ||
                    this.props.userDetails.SpouseOccupation !== "" ||
                    this.props.userDetails.SpouseRelation !== "") && (
                    <tr>
                      <td colSpan="4">
                        <span>Spouse Relation</span> :&nbsp;
                        {this.props.userDetails.SpouseRelation}
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            )}

            {this.props.admissionFormConfiguration.filter(
              (i) => i.DisplayStatus === 1 && i.AdmFormGroupSectionId === 11
            ).length > 0 && (
              <div>
                {this.state.allAchievementsData.length > 0 && (
                  <table className="table table-bordered dashboard-table mb-1 ">
                    <thead>
                      <tr>
                        <th colSpan="2" className="table-light">
                          Achievements Area &amp; Field
                        </th>
                        <th colSpan="2" className="table-light">
                          Achievements Specialization
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.allAchievementsData.map(
                        (achievement, index) => {
                          return (
                            achievement.AchievementName !== undefined &&
                              achievement.AchievementName !== "",
                            achievement.Specialization !== undefined &&
                            achievement.Specialization !== "" ? (
                              <tr key={index}>
                                <td colSpan="2">
                                  {achievement.AchievementName}
                                </td>
                                <td colSpan="2">
                                  {achievement.Specialization}
                                </td>
                              </tr>
                            ) : (
                              ""
                            )
                          );
                        }
                      )}
                    </tbody>
                  </table>
                )}
              </div>
            )}

            {this.props.admissionFormConfiguration.filter(
              (i) => i.DisplayStatus === 1 && i.AdmFormGroupSectionId === 12
            ).length > 0 && (
              <div>
                {this.state.allLanguagesData.length > 0 && (
                  <table className="table table-bordered dashboard-table mb-1 ">
                    <thead>
                      <tr>
                        <th className="table-light" width="33%">
                          Languages Known
                        </th>

                        <th className="table-light" width="28%">
                          Speaking
                        </th>
                        <th className="table-light" width="20%">
                          Reading
                        </th>
                        <th className="table-light">Writing</th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.allLanguagesData.map((languages, index) => {
                        return (
                          languages.LanguageName !== undefined &&
                            languages.LanguageName !== "",
                          languages.Speaking !== undefined &&
                            languages.Speaking !== "",
                          languages.Reading !== undefined &&
                            languages.Reading !== "",
                          languages.Writing !== undefined &&
                          languages.Writing !== "" ? (
                            <tr key={index}>
                              <td>{languages.LanguageName}</td>
                              <td>
                                {(parseInt(languages.Speaking, 10) === 3 &&
                                  "Excellent") ||
                                  (parseInt(languages.Speaking, 10) === 2 &&
                                    "Good") ||
                                  (parseInt(languages.Speaking, 10) === 1 &&
                                    "Fair")}
                              </td>
                              <td>
                                {(parseInt(languages.Reading, 10) === 3 &&
                                  "Excellent") ||
                                  (parseInt(languages.Reading, 10) === 2 &&
                                    "Good") ||
                                  (parseInt(languages.Reading, 10) === 1 &&
                                    "Fair")}
                              </td>
                              <td>
                                {(parseInt(languages.Writing, 10) === 3 &&
                                  "Excellent") ||
                                  (parseInt(languages.Writing, 10) === 2 &&
                                    "Good") ||
                                  (parseInt(languages.Writing, 10) === 1 &&
                                    "Fair")}
                              </td>
                            </tr>
                          ) : (
                            ""
                          )
                        );
                      })}
                    </tbody>
                  </table>
                )}
              </div>
            )}

            {this.props.admissionFormConfiguration.filter(
              (i) => i.DisplayStatus === 1 && i.AdmFormGroupSectionId === 13
            ).length > 0 && (
              <table className="table table-bordered dashboard-table mb-1 ">
                <thead>
                  <tr>
                    <th colSpan="4" className="table-light">
                      Foreign Student Visa Details
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td colSpan="4">
                      <span>Is Foreign Student</span> :&nbsp;
                      {this.props.userDetails.IsForeignStudent === 1
                        ? "Yes"
                        : "No"}
                    </td>
                  </tr>
                  {this.props.userDetails.IsForeignStudent === 1 && (
                    <tr>
                      <td>
                        <span>Passport No</span> :&nbsp;
                        {this.props.userDetails.PassportNo}
                      </td>
                      <td>
                        <span>Visa Details</span> :&nbsp;
                        {this.props.userDetails.VisaDetails}
                      </td>
                      <td>
                        <span>Issue Date</span> :&nbsp;
                        {moment(this.props.userDetails.IssueDate).isValid()
                          ? moment(this.props.userDetails.IssueDate).format(
                              "DD-MM-YYYY"
                            )
                          : ""}
                      </td>
                      <td>
                        <span>Expiry Date</span> :&nbsp;
                        {moment(this.props.userDetails.ExpiryDate).isValid()
                          ? moment(this.props.userDetails.ExpiryDate).format(
                              "DD-MM-YYYY"
                            )
                          : ""}
                      </td>
                    </tr>
                  )}
                  {this.props.userDetails.IsForeignStudent === 1 && (
                    <tr>
                      <td>
                        <span>Name Of Country</span> :&nbsp;
                        {this.props.userDetails.NameOfCountry}
                      </td>
                      <td>
                        <span>Type of VISA</span> :&nbsp;
                        {this.props.userDetails.TypeOfVISA}
                      </td>
                      <td colSpan="2" />
                    </tr>
                  )}
                </tbody>
              </table>
            )}
          </div>
        </div>

        {/* <header className="print-header displayPrintOnly">
            {this.props.admissionFormList.length > 0 && (
              <div>
                {this.props.admissionFormList
                  .filter(data => {
                    return data.ID === parseInt(this.props.FormId, 10);
                  })
                  .map((item, index) => {
                    return (
                      <div className="documentData" key={index}>
                        <h2 className="text-center"> {item.FormGroupName}</h2>
                        <ul className="documentDataList">
                          <li>
                            <strong>Application No</strong> :{" "}
                            {this.state.AdmissionNo || ""}
                          </li>
                          <li>
                            <strong>Form Fees</strong> :{" "}
                            {`₹${this.state.FormFees || ""}`}
                          </li>
                        </ul>
                        <p className="formDate">
                          <strong>Application Date</strong> :{" "}
                          {this.state.AdmissionDate}
                        </p>
                      </div>
                    );
                  })}
              </div>
            )}
          </header> */}
        <AcademicInfoPrint FormId={this.props.FormId} />

        {keys.websiteSetting.signUpContent === "nvu" && (
          <p className="printNote">
            <strong>Note: </strong>For offline payment, please take print of
            your form, attach all your documents, carry your original documents
            (for verification) and visit Admission Cell, Navrachana University,
            Vasna Bhayli Road, Vadodara 391410. For any doubt, call 0265-2617000
          </p>
        )}

        <div>
          <button
            className="btn no_print btn-lg btn-success theme-btn display-inline"
            type="button"
            onClick={() => window.print()}
          >
            <i className="fa fa-print" aria-hidden="true" />
            Print
          </button>
          {this.state.admStatusDetails.length > 0 &&
            this.state.PendingAmount > 0 &&
            this.state.IsVerifiedByUser !== 0 &&
            this.props.auth.paymentvendor.length > 0 &&
            this.state.admStatusDetails.map((item, index) => {
              return (
                <button
                  key={index}
                  className="btn no_print btn-lg btn-success mr-0 theme-btn btnPayment display-inline btn-info"
                  type="button"
                  onClick={() => this.makeOnlinePayment(item)}
                >
                  <i className="fa fa-money" aria-hidden="true" />
                  {keys.websiteSetting.signUpContent === "nvu"
                    ? "Online Payment"
                    : "Make Payment"}
                </button>
              );
            })}
        </div>
      </div>
    );
  }
}
function mapStateToProps({
  auth,
  userDetails,
  update,
  achievementByStudent,
  languageKnownByStudent,
  admissionFormList,
  admissionProgram,
  admissionVerifyDetails,
  admissionFormConfiguration,
  admissionTotalFormFees,
  admissionStudentStatusDetails,
}) {
  return {
    auth,
    userDetails,
    achievementByStudent,
    languageKnownByStudent,
    admissionFormList,
    admissionProgram,
    update,
    admissionVerifyDetails,
    admissionFormConfiguration,
    admissionTotalFormFees,
    admissionStudentStatusDetails,
  };
}
export default connect(mapStateToProps, {
  getUserDetailsByUserId,
  getAchievementsByStudentId,
  getLanguageknownsByStudentId,
  clearUpdate,
  getFormVerifyDetailsByStudentId,
  admissionInsertVerifyDetails,
  getAllAdmissionFormConfigurationByFormId,
  getAdmissionTotalFormFeesByStudentId,
  payOnlinePayment,
  getStudentStatusDetailsByUserId,
  WithoutAdmissionFormFeesDetails,
})(AdmissionVerifyPrint);



// WEBPACK FOOTER //
// ./src/components/StudentAccount/AdmissionPrint.js